import config from '../../../config';

const baseUrl = `${config.apiUrl()}/ReferralCampaigns`;

export default {
  getActiveReferralCampaignDiscountUrl: (): string => `${baseUrl}/active-discount`,
};
